module.exports = __webpack_public_path__ + "img/playCircle.d7a54667.png";